import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Privacy Policy</h1>
      <p style={styles.date}>
        Effective Date: {new Date().toLocaleDateString()}
      </p>

      <section style={styles.section}>
        <p>
          RIVNUE ("we", "our", or "us") operates the RIVNUE mobile application,
          a video-based marketplace that allows users to post, discover, and
          purchase products through short-form videos.
        </p>
      </section>

      <section style={styles.section}>
        <h2>1. Information We Collect</h2>

        <h3>Personal Information</h3>
        <ul>
          <li>Name or username</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Profile image</li>
        </ul>

        <h3>Product & Content Data</h3>
        <ul>
          <li>Product name, category, price, and description</li>
          <li>Images, thumbnails, and videos</li>
          <li>Comments, likes, and shares</li>
        </ul>

        <h3>Payment Information</h3>
        <p>
          Payments may be made using local payment methods, mobile money, or
          credit/debit cards. RIVNUE does not store full card details. All
          transactions are handled securely by third-party payment providers.
        </p>

        <h3>Automatically Collected Data</h3>
        <ul>
          <li>Device and app information</li>
          <li>IP address</li>
          <li>Usage analytics and interaction data</li>
        </ul>
      </section>

      <section style={styles.section}>
        <h2>2. How We Use Your Information</h2>
        <ul>
          <li>Create and manage user accounts</li>
          <li>Display and promote products</li>
          <li>Enable purchases and payments</li>
          <li>Provide video-based product feeds</li>
          <li>Improve app performance and security</li>
          <li>Prevent fraud and abuse</li>
        </ul>
      </section>

      <section style={styles.section}>
        <h2>3. Sharing of Information</h2>
        <p>
          We may share data with payment processors, cloud storage providers,
          and analytics services. We do not sell or rent user data to third
          parties.
        </p>
      </section>

      <section style={styles.section}>
        <h2>4. User-Generated Content</h2>
        <p>
          Content you upload (products, videos, comments) may be visible to
          other users. You are responsible for the content you share.
        </p>
      </section>

      <section style={styles.section}>
        <h2>5. Data Security</h2>
        <p>
          We use industry-standard security measures including encryption and
          secure servers to protect your data. However, no system is completely
          secure.
        </p>
      </section>

      <section style={styles.section}>
        <h2>6. Children’s Privacy</h2>
        <p>
          RIVNUE is not intended for children under the age of 13. We do not
          knowingly collect personal data from children.
        </p>
      </section>

      <section style={styles.section}>
        <h2>7. Your Rights</h2>
        <p>
          You may request access, correction, or deletion of your personal data
          by contacting us.
        </p>
      </section>

      <section style={styles.section}>
        <h2>8. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Updates will be
          posted on this page.
        </p>
      </section>

      <section style={styles.section}>
        <h2>9. Contact Us</h2>
        <p>
          <strong>App:</strong> RIVNUE <br />
          <strong>Email:</strong> support@rivnue.com <br />
          <strong>Developer:</strong> RIVNUE Team
        </p>
      </section>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '900px',
    margin: '0 auto',
    padding: '24px',
    fontFamily: 'Arial, sans-serif',
    lineHeight: 1.7,
    color: '#333',
  },
  title: {
    textAlign: 'center',
    marginBottom: '10px',
  },
  date: {
    textAlign: 'center',
    color: '#777',
    marginBottom: '30px',
  },
  section: {
    marginBottom: '28px',
  },
};

export default PrivacyPolicy;
